module.exports = __webpack_public_path__ + "img/icon_notice_tip.88bb617b.png";